import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 8,
	viewBox: "0 0 12 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.960929 0.699951C0.609367 0.699951 0.374992 0.895264 0.257804 1.20776C0.101554 1.52026 0.179679 1.7937 0.414054 2.02808L5.45312 7.06714C5.60937 7.22339 5.76562 7.30151 5.99999 7.30151C6.1953 7.30151 6.39062 7.22339 6.54687 7.06714L11.5859 2.02808C11.8203 1.7937 11.8594 1.52026 11.7422 1.20776C11.5859 0.895264 11.3516 0.699951 11.0391 0.699951H0.960929Z",
		fill: "currentColor"
	})
});
export default SvgCaretDown;
